import { render, staticRenderFns } from "./statisticsSales.vue?vue&type=template&id=4e557668&scoped=true&"
import script from "./statisticsSales.vue?vue&type=script&lang=js&"
export * from "./statisticsSales.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSales.vue?vue&type=style&index=0&id=4e557668&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e557668",
  null
  
)

export default component.exports